import React from "react";
import ReactPlayer from "react-player";

const VideoSection = ({ videos }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {videos.map((video, key) => (
        <div className="w-full overflow-hidden" key={key}>
          <ReactPlayer
            url={video.videoURL}
            className="w-full h-full rounded-lg aspect-video"
            style={{
              aspectRatio: "16/9",
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default VideoSection;
